import React from "react";
import { useNavigate } from "react-router-dom";
import { useCatalogue } from "../../../../hooks/useCatalogue";

function Courses({ session }) {
  const navigate = useNavigate();
  const { departments, loading } = useCatalogue();

  if (loading) return <p className="fc_loading">Loading departments...</p>;

  const depts = departments.filter((d) => d.code !== "ext");

  return (
    <div className="fc_dept_grid">
      {depts.map((dept) => (
        <button
          key={dept._id}
          className="fc_dept_row"
          onClick={() => navigate(`/admin/faculty/${session}/courses/${dept.code}`)}
        >
          <span className="fc_dept_dot" />
          <span className="fc_dept_name">{dept.name}</span>
          <span className="fc_dept_code">{dept.code.toUpperCase()}</span>
        </button>
      ))}
    </div>
  );
}

export default Courses;
